module.exports = __webpack_public_path__ + "img/fakta.158a7bc2.png";